export default __webpack_public_path__ + "static/media/shimmeringinvocation.9e784874.png";